import { DialogInOne, LoadingDialog } from 'src/components';
import { ConsumedReferralCode } from '../../types/GetDetailsRes';
import useTranslation from 'src/hooks/useTranslation';
import { DataGrid } from '@mui/x-data-grid';
import { dataGridDefaults } from 'src/utils/constant';
import { useGenGridCol } from 'src/utils/ComponentHelper';
import { TableColumnKey, TableRow } from '../../types/Table';
import { useMemo, useState } from 'react';
import { useAlerting } from 'src/hooks';
import { useQuery } from 'react-query';
import { CustomPagination, NoRowsOverlay } from 'src/components/Layout';
import APIs from 'src/api';
import { toDisplayTime } from 'src/utils';
import { getCustomerApplicationStatusDisplayValue } from 'src/helper/displayValue/getCustomerApplicationStatusDisplayValue';

const PAGE_SIZE = 20;

function UsageDetailsDialog({
  isOpen,
  closeDialog,
  row,
}: {
  isOpen: boolean;
  closeDialog: () => void;
  row: TableRow | null;
}) {
  const { t, translate } = useTranslation('referralCode');

  const [apiRes, setApiRes] = useState<{
    count: number;
    rows: ConsumedReferralCode[];
  } | null>(null);
  const [page, setPage] = useState(0);

  const { alerting } = useAlerting();

  const [isLoading, setIsLoading] = useState(false);

  const onClose = () => {
    closeDialog();
    setApiRes(null);
    setPage(0);
  };

  const params = {
    referralCode: row?.[TableColumnKey.ReferralCode] || '',
    distributorAgentId: row?.[TableColumnKey.DistributorAgentId] || '',
    programName: row?.[TableColumnKey.ProgramName] || '',
    page,
    pageSize: PAGE_SIZE,
  };

  const fetchUsageDetails = async () => {
    setIsLoading(true);

    return APIs.distributorAgentManagement.referralCode.getDetails(params);
  };

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  useQuery({
    enabled: isOpen,
    queryKey: ['referralCodeUsageDetails', params],
    queryFn: fetchUsageDetails,

    onSettled: (res, err) => {
      // if (!res || err || res.count === 0) {
      //   onClose();

      //   if (res?.count === 0) {
      //     return alerting('warning', t('noUsageDetailsData'));
      //   }

      //   return;
      // }

      setIsLoading(false);

      setApiRes(res || null);
    },
  });

  const rows = useMemo(
    () =>
      apiRes?.rows.map((detail, index) => {
        return {
          id: detail.id,
          order: `#${page * PAGE_SIZE + index + 1}`,
          applicationStatus: getCustomerApplicationStatusDisplayValue(
            detail.customerApplicationStatus,
            translate
          ),
          usedBy: detail.email,
          usedTime: toDisplayTime(detail.createdDate),
        };
      }),
    [apiRes]
  );

  const totalRowCount = apiRes?.count || 0;

  const columns = [
    useGenGridCol('order'),
    // useGenGridCol('applicationStatus'),
    useGenGridCol('usedBy'),
    useGenGridCol('usedTime'),
  ];

  return (
    <>
      <LoadingDialog forceOpen={(isOpen && !apiRes) || isLoading} />

      <DialogInOne
        title={t('usageDetails')}
        dialogHeight={{ maxHeight: '90%' }}
        self={{
          open: isOpen && !!apiRes,
          onClose,
        }}
        content={
          <DataGrid
            {...dataGridDefaults}
            rows={rows || []}
            rowCount={totalRowCount}
            columns={columns}
            page={page}
            onPageChange={onPageChange}
            components={{
              NoRowsOverlay,
              Footer: CustomPagination,
            }}
            componentsProps={{
              footer: { totalRecords: totalRowCount },
            }}
          />
        }
        isConfirmHidden
        onConfirm={() => {}}
        onCancel={onClose}
      />
    </>
  );
}

export default UsageDetailsDialog;
